import {
  ENEMY_ATTACK_COOLDOWN_MS,
  ENEMY_INVESTIGATE_MS,
  ENEMY_SHOT_SPEED,
} from './rangerTuning';

const SPY_PALETTE = {
  helmet: 0x536d67,
  helmetDark: 0x243b39,
  torso: 0x69847b,
  vest: 0x2e4544,
  accent: 0xa9d7c9,
  classMark: 0x8bd2c7,
  outline: 0x172421,
  pack: 0x233a37,
  rifle: 0x17201d,
  rifleStock: 0x6c4d30,
  skin: 0xb98a5c,
  role: 'spy',
  iconAssetPath: '/game-icons/ranger-scout.svg',
};

export const CHARACTER_PALETTES = {
  ranger: {
    helmet: 0x53633d,
    helmetDark: 0x29341f,
    torso: 0x697a45,
    vest: 0x313b2c,
    accent: 0xd6b76e,
    classMark: 0xd6b76e,
    outline: 0x171d13,
    pack: 0x2b3526,
    rifle: 0x20261e,
    rifleStock: 0x6b4827,
    skin: 0xc59665,
    role: 'ranger',
    iconAssetPath: '/game-icons/ranger.svg',
  },
  'ranger-scout': SPY_PALETTE,
  'ranger-spy': SPY_PALETTE,
  'ranger-medic': {
    helmet: 0x827b60,
    helmetDark: 0x4c4737,
    torso: 0x9a9273,
    vest: 0x504c3e,
    accent: 0xf1eee2,
    classMark: 0xf1eee2,
    outline: 0x302c22,
    pack: 0x4b4535,
    rifle: 0x25231b,
    rifleStock: 0x715137,
    skin: 0xc89d6d,
    role: 'medic',
    iconAssetPath: '/game-icons/ranger-medic.svg',
  },
  'ranger-heavy': {
    helmet: 0x62543c,
    helmetDark: 0x2c261c,
    torso: 0x77643f,
    vest: 0x332d22,
    accent: 0xf0c86b,
    classMark: 0xf0c86b,
    outline: 0x19140e,
    pack: 0x312b20,
    rifle: 0x17140f,
    rifleStock: 0x6f4b2b,
    skin: 0xbd8c5e,
    role: 'heavy',
    iconAssetPath: '/game-icons/ranger.svg',
  },
};

export const RANGER_ICON_ASSET_PATHS = {
  ranger: '/game-icons/ranger.svg',
  'ranger-medic': '/game-icons/ranger-medic.svg',
  'ranger-spy': '/game-icons/ranger-scout.svg',
};

export const RANGER_ART_DIRECTION = {
  sourceReference: 'OpenGameArt Isometric 20x20 sprites for a tactical shooter',
  sourceUrl: 'https://opengameart.org/content/isometric-20x20-sprites-for-a-tactical-shooter',
  style: 'tactical top-down arcade enamel with helmet, vest, pack, rifle, and class mark silhouettes',
  runtimeApproach: 'Phaser-built vector shapes using icon-matched palettes for mobile readability',
};

export function getRangerPlayableVisual(classId = 'ranger') {
  return CHARACTER_PALETTES[classId] ?? CHARACTER_PALETTES.ranger;
}

export const ENEMY_ARCHETYPES = {
  basic: {
    type: 'basic',
    mark: 'stripe',
    health: 1,
    speedMultiplier: 1,
    body: 0x6b5140,
    helmet: 0x8f7552,
    visor: 0xf0c05c,
    accent: 0xf0c05c,
    shotSpeed: ENEMY_SHOT_SPEED,
    attackCooldownMs: ENEMY_ATTACK_COOLDOWN_MS,
    investigationMs: ENEMY_INVESTIGATE_MS,
  },
  heavy: {
    type: 'heavy',
    mark: 'armor',
    health: 3,
    speedMultiplier: 0.72,
    body: 0x584638,
    helmet: 0x6d5d46,
    visor: 0xffd889,
    accent: 0xffd889,
    shotSpeed: ENEMY_SHOT_SPEED * 0.92,
    attackCooldownMs: 920,
    investigationMs: 760,
    scale: 1.08,
  },
  elite: {
    type: 'elite',
    mark: 'chevron',
    health: 2,
    speedMultiplier: 1.1,
    body: 0x65454b,
    helmet: 0x8a5f62,
    visor: 0xff8f70,
    accent: 0xff8f70,
    shotSpeed: ENEMY_SHOT_SPEED * 1.15,
    attackCooldownMs: 760,
    investigationMs: 420,
  },
};
